import { render, staticRenderFns } from "./LoginAgreement.vue?vue&type=template&id=f46b9512&scoped=true&"
import script from "./LoginAgreement.vue?vue&type=script&lang=js&"
export * from "./LoginAgreement.vue?vue&type=script&lang=js&"
import style0 from "./LoginAgreement.vue?vue&type=style&index=0&id=f46b9512&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46b9512",
  null
  
)

export default component.exports